<template>
  <el-card>
    <div slot="header">
      <h1>{{isEdit ? '编辑': '创建'}}公司</h1>
    </div>
    <div class="form-container">
      <el-form v-loading="loading" ref="form" :model="form" :rules="rules" label-width="190px">
        <el-form-item label="公司名称" prop="name">
          <el-input v-model="form.name"/>
        </el-form-item>
        <el-form-item label="企业邮箱" prop="enableEmail">
          <el-switch
            v-model="form.enableEmail"
          >
          </el-switch>
        </el-form-item>
        <template v-if="form.enableEmail">
          <el-form-item label="邮箱后缀" prop="emailSuffix" key="emailSuffix">
            <el-input v-model="form.emailSuffix"/>
          </el-form-item>
        </template>
        <el-form-item label="钉钉应用" prop="enableDingtalk">
          <el-switch
            v-model="form.enableDingtalk"
          >
          </el-switch>
        </el-form-item>
        <template v-if="form.enableDingtalk">
          <el-form-item label="钉钉应用AppKey" prop="dingtalkConfig.eAppKey">
            <el-input v-model="form.dingtalkConfig.eAppKey"/>
          </el-form-item>
          <el-form-item label="钉钉应用AppSecret" prop="dingtalkConfig.eAppSecret">
            <el-input v-model="form.dingtalkConfig.eAppSecret"/>
          </el-form-item>
          <el-form-item label="钉钉扫码应用AppId" prop="dingtalkConfig.oauthAppId">
            <el-input v-model="form.dingtalkConfig.oauthAppId"/>
          </el-form-item>
          <el-form-item label="钉钉扫码应用AppSecret" prop="dingtalkConfig.oauthAppSecret">
            <el-input v-model="form.dingtalkConfig.oauthAppSecret"/>
          </el-form-item>
        </template>
        <el-form-item label="手机号登陆" prop="enableEmail">
          <el-switch
            v-model="form.enableMobile"
          >
          </el-switch>
        </el-form-item>
        <el-form-item class="buttons">
          <el-button type="primary" @click="submitForm">保存</el-button>
        </el-form-item>


      </el-form>
    </div>
  </el-card>
</template>

<script>

  import { createNamespacedHelpers } from 'vuex'
  import _ from 'lodash'

  const { mapGetters } = createNamespacedHelpers('companies')

  export default {
    data() {
      return {
        isEdit: false,
        loading: false,
        form: {
          name: '',
          enableEmail: false,
          emailSuffix: '',
          enableDingtalk: false,
          enableMobile: false,
          dingtalkConfig: {
            eAppKey: '',
            eAppSecret: '',
            oauthAppId: '',
            oauthAppSecret: '',
          },

        },
        rules: {
          name: this.$formHelper.requiredRuleFactory('请输入公司名称，公司名称不能为空。'),
          emailSuffix: this.$formHelper.rules.emailSuffixRequired,
          dingtalkConfig: {
            eAppKey: this.$formHelper.requiredRuleFactory('请输入钉钉应用AppKey，钉钉应用AppKey不能为空。'),
            eAppSecret: this.$formHelper.requiredRuleFactory('请输入钉钉应用AppSecret，钉钉应用AppSecret不能为空。'),
            oauthAppId: this.$formHelper.requiredRuleFactory('请输入钉钉扫码应用AppId，钉钉扫码应用AppId不能为空。'),
            oauthAppSecret: this.$formHelper.requiredRuleFactory('请输入钉钉扫码应用AppSecret，钉钉扫码应用AppSecret不能为空。'),
          }
        }
      }
    },
    computed: {
      ...mapGetters(['document'])
    },
    methods: {
      async submitForm() {
        await this.$formHelper.promisedValidate(this.$refs.form)
        this.loading = true
        let company = {...this.form}

        if (company.enableEmail === false) {
          company.emailSuffix = ''
        }

        if (company.enableDingtalk === false) {
          company.dingtalkConfig = _.mapValues(company.dingtalkConfig, () => '')
        }

        try {
          await this.$store.dispatch(this.isEdit ? 'companies/update' : 'companies/create', company)
        } finally {
          this.loading = false
        }
        this.$message.success('公司保存成功')
        this.$router.push({ name: 'company-company' })
      }
    },
    watch: {
      document(newValue, preValue) {
        if (!_.isEqual(newValue, preValue)) {
          this.form = {...this.form, ...newValue}
        }
      }
    },
    mounted() {

      const { id } = this.$route.params
      if (id > 0) {
        this.isEdit = true
      }
      if (this.isEdit) {
        const { document } = this.$store.dispatch('companies/document', id)
      }
    }
    ,
    destroyed(){
      this.$store.dispatch('companies/resetDocument')
    }
  }
</script>

<style scoped>

</style>
